import { m, useReducedMotion } from "framer-motion";
import { fadeUp, staggerContainer, transition, viewport } from "./presets";

export default function StaggerReveal({ children, className }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <m.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={staggerContainer}
        >
            {children}
        </m.div>
    );
}

export function StaggerItem({ children, className }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    // Each item observes its own visibility rather than inheriting the parent
    // container's whileInView state. Inheriting from the container breaks for
    // long single-column lists (e.g. the blog grid stacked on mobile): the
    // container's `amount` threshold is relative to the container's full
    // height, so a tall stack of items may never satisfy it, leaving every
    // item stuck at opacity 0.
    return (
        <m.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={fadeUp}
            transition={transition}
        >
            {children}
        </m.div>
    );
}
